import request from '../utils/request';

export interface LoginParams {
  username: string;
  password: string;
}

export interface AdminInfo {
  id: number;
  username: string;
  nickname?: string;
  level_id: number;
  status: number;
  addtime?: string;
  role: string;
}

export interface AdminUser {
  id: number;
  username: string;
  nickname?: string;
  level_id: number;
}

export interface UserInfo {
  id: number;
  username: string;
  nickname?: string;
  status: number;
  addtime?: string;
  a_address: string;
  b_address: string;
  uid: number;
  balance: string;
  wallet_status: number;
}

export interface LoginResponse {
  token: string;
  admin: AdminUser;
}

export interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

export interface UserListResponse {
  list: UserInfo[];
  total: number;
}

export interface Statistics {
  totalUsers: number;
  activeUsers: number;
  totalAdmins: number;
}

export interface CreateAdminParams {
  username: string;
  password: string;
  level_id: number;
  status: number;
  weburl?: string;
}

export interface UpdateAdminParams {
  id: number;
  status?: number;
  oldPassword?: string;
  newPassword?: string;
}

export interface AdminListParams {
  page: number;
  pageSize: number;
  keyword?: string;
}

export interface AdminListResponse {
  list: AdminInfo[];
  total: number;
}

export interface CaptchaResponse {
  question: string;
  answer: string;
}

export interface VerifyCaptchaParams {
  id: string;
  answer: string;
}

export interface UpdatePasswordParams {
  oldPassword: string;
  newPassword: string;
}

// 登录
export const login = (params: LoginParams): Promise<ApiResponse<LoginResponse>> => {
  return request.post('/admin/login', params);
};

// 获取管理员信息
export const getAdminInfo = (): Promise<ApiResponse<AdminUser>> => {
  return request.get('/admin/info');
};

// 获取用户列表
export const getUsers = (params: { 
  page: number; 
  pageSize: number;
  keyword?: string;
  uid?: number;
  wallet_status?: number;
}): Promise<ApiResponse<UserListResponse>> => {
  return request.get('/admin/users', { params });
};

// 获取用户详情
export const getUserDetail = (id: number): Promise<ApiResponse<UserInfo>> => {
  return request.get(`/admin/users/${id}`);
};

// 更新用户状态
export const updateUserStatus = (id: number, status: number): Promise<ApiResponse<null>> => {
  return request.put(`/admin/users/${id}/status`, { status });
};

// 获取统计数据
export const getStatistics = (): Promise<ApiResponse<Statistics>> => {
  return request.get('/admin/statistics');
};

export const getAdmins = () => {
  return request.get<AdminInfo[]>('/admin/list');
};

export const getAdminList = (params: AdminListParams): Promise<ApiResponse<AdminListResponse>> => {
  return request.get('/admin/list', { params });
};

// 创建管理员
export const createAdmin = (params: CreateAdminParams): Promise<ApiResponse<null>> => {
  return request.post('/admin/create', params);
};

// 更新管理员状态
export const updateAdmin = (params: UpdateAdminParams): Promise<ApiResponse<null>> => {
  return request.put('/admin/update', { id: params.id, status: params.status });
};

// 删除管理员
export const deleteAdmin = (id: number): Promise<ApiResponse<null>> => {
  return request.delete(`/admin/delete/${id}`);
};

export const getAdminStats = () => {
  return request.get<Statistics>('/admin/stats');
};

// 删除用户
export const deleteUser = (id: number): Promise<ApiResponse<null>> => {
  return request.delete(`/admin/users/${id}`);
};

export const getCaptcha = (): Promise<ApiResponse<CaptchaResponse>> => {
  return request.get('/admin/captcha');
};

export const verifyCaptcha = (params: VerifyCaptchaParams): Promise<ApiResponse<boolean>> => {
  return request.post('/admin/verify-captcha', params);
};

// 修改密码
export const updatePassword = async (params: UpdatePasswordParams): Promise<ApiResponse<null>> => {
  return request.put('/admin/password', {
    oldPassword: params.oldPassword,
    newPassword: params.newPassword
  });
};

export {};